import { transformComponent } from '@formily/antdv-x3/esm/__builtins__/shared'
import { PreviewText } from '@formily/antdv-x3'
import { AutoComplete, AutoCompleteProps } from 'ant-design-vue'
import { connect, mapProps, mapReadPretty } from '@formily/vue'

const TransformElInput = transformComponent<AutoCompleteProps>(AutoComplete)

const AutoCompleteInput = connect(
  TransformElInput,
  mapProps({ dataSource: 'options' }),
  mapReadPretty(PreviewText.Input),
)

export default AutoCompleteInput
